// src/belediye/pages/gorevler/tarafSecimi.js
//
// FAZ-91 — TARAF SEÇİMİ (Verdiklerim ↔ Bana Gelenler).
//
// Seçim HATIRLANIR, SORULMAZ. Kullanıcının kendi sorduğu "her girişte iki
// seçenek mi sorsa?" fikri elendi: alt bardaki bir yuva günde onlarca kez
// tıklanır; her tıklamada araya soru girmesi tek dokunuşluk işi ikiye çıkarır
// ve kullanıcıların ezici çoğunluğu HEP AYNI cevabı verir — sorunun bilgi
// değeri neredeyse sıfır. Seçim gerekli, ama SORU olarak değil.
//
// VARSAYILAN "bana" (açık madde A-3): telefonda Talepler'e giren kişi
// çoğunlukla KENDİ işini arar; başkasına verdiğini takip etmek ikincil bir
// niyettir.

import { useCallback, useEffect, useMemo, useState } from "react";

export const TARAF_ANAHTARI = "talepler.taraf.v1";

/**
 * @param {boolean} cift  hem verir hem alır mı
 * @param {boolean} verir tasks.view_created
 * @param {boolean} alir  tasks.view_assigned | tasks.view_unit_pool
 * @returns {{taraf: "bana"|"verdim", setTaraf: Function, secilebilir: boolean}}
 */
export function useTarafSecimi({ cift, verir, alir }) {
  // Tek yuvalı rolde taraf bir SEÇİM değil, olgudur.
  const zorunlu = useMemo(() => {
    if (cift) return null; // seçim serbest
    if (verir) return "verdim"; // yalnız veren (başkan, genel admin)
    if (alir) return "bana"; // yalnız alan (birim personeli, halk masası, saha)
    return null;
  }, [cift, verir, alir]);

  const [taraf, setTarafRaw] = useState(() => {
    if (zorunlu) return zorunlu;
    try {
      return window.localStorage.getItem(TARAF_ANAHTARI) === "verdim"
        ? "verdim"
        : "bana";
    } catch {
      return "bana";
    }
  });

  // İzin sonradan daralırsa (rol güncellemesi) zorunlu tarafa düş.
  // Aksi hâlde hatırlanan seçim, artık yetkisi olmayan bir sayfayı açardı.
  useEffect(() => {
    if (zorunlu && taraf !== zorunlu) setTarafRaw(zorunlu);
  }, [zorunlu, taraf]);

  const setTaraf = useCallback(
    (yeni) => {
      if (zorunlu) return; // tek yuvalı rolde değiştirilemez
      setTarafRaw(yeni);
      try {
        window.localStorage.setItem(TARAF_ANAHTARI, yeni);
      } catch {
        /* özel mod / kota — seçim oturumluk kalır, akış bozulmaz */
      }
    },
    [zorunlu],
  );

  return { taraf: zorunlu || taraf, setTaraf, secilebilir: !zorunlu };
}
